import { defineNuxtPlugin, useRuntimeConfig } from "#app";
import { c as createYmapsOptions } from "../vue-yandex-maps-CjZi1za-.js";
const nuxt3Plugin = defineNuxtPlugin(() => {
  createYmapsOptions(useRuntimeConfig().public.yandexMaps);
});
export {
  nuxt3Plugin as default
};
